import { ProductPriceDto } from "src/api/search_v2";
import { isAndroid, isIOS } from "../utils";
import { DataLayerAddToCartInteractionDataApps, DataLayerAddToCartInteractionDataWeb, DataLayerAuthorisePaymentInteractionDataApps, DataLayerAuthorisePaymentInteractionDataWeb } from "./interactions/shopping-cart/shoppingCartInteractionTypes";
import { DataLayerMainGridEventDataApps, DataLayerMainGridEventDataWeb, DataLayerMainGridEventInteractionDataApps, DataLayerMainGridInteractionDataWeb } from "./page-views/main-grid/mainGridAnalyticsTypes";
import { DataLayerPDPEventDataApps, DataLayerPDPEventDataWeb } from "./page-views/pdp/pdpTypes";
import { DataLayerSearchEventDataApps, DataLayerSearchEventDataWeb, DataLayerSearchInteractionDataApps, DataLayerSearchInteractionDataWeb } from "./page-views/search/searchAnalyticsTypes";
import { AnalyticsData, CheckoutAnalyticsData } from "./page-views/shopping-cart/shoppingCartAnalyticsTypes";
import { useQueryClient, UseQueryResult } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { PageUniverseDto } from "src/api/search";

export interface ViewDataLayerObject {
    event: 'front_page_view';
    data: AnalyticsData | CheckoutAnalyticsData | DataLayerSearchEventDataWeb | DataLayerMainGridEventDataWeb | DataLayerPDPEventDataWeb; // Permitir cualquier tipo de datos analíticos definidos
}

export interface AppViewDataLayerObject {
    eventType: 'PAGE_VIEW';
    eventData: AnalyticsData | CheckoutAnalyticsData | DataLayerSearchEventDataApps | DataLayerPDPEventDataApps | DataLayerMainGridEventDataApps;  // Permitir cualquier tipo de datos analíticos definidos
}

export interface InteractionDataLayerObject {
    event: 'front_apply_filter' | 'front_search' | 'front_add_to_cart' | 'front_checkout_payment_authorize';
    data: DataLayerMainGridInteractionDataWeb | DataLayerSearchInteractionDataWeb | DataLayerAddToCartInteractionDataWeb | DataLayerAuthorisePaymentInteractionDataWeb
}

export interface AppInteractionDataLayerObject {
    eventType: '', // todavia no las tenemos definidas, están todavía trabajando con las vistas página
    eventData: DataLayerMainGridEventInteractionDataApps | DataLayerSearchInteractionDataApps | DataLayerAddToCartInteractionDataApps | DataLayerAuthorisePaymentInteractionDataApps
}

export interface AppStoreData {
    storeId: number, 
    country: string,
    language: string

}

export type AppsPageType = 'MY_ACCOUNT_ACCOUNT_MENU' | 'AR_VIEWER' | 'CATEGORY_VIEW' | 'CHAT' | 'CHECKOUT_ADD_PERSONAL_DETAILS' | 
    'CHECKOUT_PERSONAL_DETAILS_GUEST' | 'CHECKOUT_DROP_POINT_DETAIL' | 'CHECKOUT_DROP_POINT_LIST' | 
    'CHECKOUT_DROP_POINT_OPENING_TIMES' | 'CHECKOUT_HOME_ADDRESS_LIST' | 'CHECKOUT_MODIFY_PERSONAL_DETAILS' | 
    'CHECKOUT_PAYMENT_METHOD' | 'CHECKOUT_PAYMENT_DATA' | 'CHECKOUT_PAYMENT_DATA_CVV2' | 
    'CHECKOUT_ORDER_REVIEW' | 'CHECKOUT_SHIPPING_METHOD' | 'CHECKOUT_STORE_DETAIL' | 'CHECKOUT_STORE_LIST' | 
    'CONFIRMATION_REQUEST_PURCHASE_CONDITIONS_AND_PRIVACY_POLICY' | 'CONTACT' | 'COMING_SOON_CONFIRMATION' | 
    'COMING_SOON_FORM' | 'E-GIFTCARD' | 'GIFTCARD_DETAILS' | 'E_GIFTCARD_DATA_EMAIL' | 'E_GIFTCARD_DATA_USER' | 
    'E_GIFTCARD' | 'E_GIFTCARD_SHIPPING_METHOD' | 'SHOPPING_CART_EMPTY' | 'EXPERIMENT_ACTIVATION' | 'GIFT_BOX' | 
    'GIFTCARD' | 'GIFT_OPTIONS' | 'GIFT_TICKET' | 'GIFT_VIDEO' | 'HELP_CENTER' | 'HOME' | 'IMAGE_SEARCH' | 'MENU' | 
    'MULTI_WISHLIST' | 'MULTI_WISHLIST_LOGIN' | 'MULTI_WISHLIST_SETTINGS' | 'MULTI_WISHLIST_SHARED_DELETED_LIST' | 
    'MULTI_WISHLIST_SHARED_PUBLIC_LIST' | 'MY_ACCOUNT_ADD_PAYMENT_CARD' | 'MY_ACCOUNT_ADDRESSES' | 
    'MY_ACCOUNT_CHANGE_EMAIL' | 'MY_ACCOUNT_CHANGE_PASSWORD' | 'MY_ACCOUNT_CHANGE_PHONE' | 
    'MY_ACCOUNT_EDIT_ADDRESS' | 'MY_ACCOUNT_NEW_ADDRESS' | 'MY_ACCOUNT_NEW_AFFINITY_CARD' | 
    'MY_ACCOUNT_NEW_BANK_CARD' | 'MY_ACCOUNT_NEW_EMPLOYEE_CARD' | 'MY_ACCOUNT_NEW_GIFT_CARD' | 
    'MY_ACCOUNT_NEWSLETTER' | 'MY_ACCOUNT_ORDER_DETAILS' | 'MY_ACCOUNT_ORDER_DETAILS_IN_STORE' | 
    'MY_ACCOUNT_ORDER_DETAILS_REFUND' | 'MY_ACCOUNT_ORDER_EXCHANGEABLE_LIST' | 'MY_ACCOUNT_ORDERS_LIST_ONLINE' | 
    'MY_ACCOUNT_ORDER_RETURNS_EXCHANGES_ITEMS_SUMMARY' | 'MY_ACCOUNT_PAYMENT_CARDS' | 'MY_ACCOUNT_PROFILE_MENU' | 
    'MY_ACCOUNT_RETURNS_DETAILS' | 'MY_ACCOUNT_SELECT_LANGUAGE' | 'MY_ACCOUNT_SETTINGS_MENU' | 'MY_ACCOUNT_STORES' | 
    'MY_ACCOUNT_ORDERS_LIST_IN_STORE' | 'MY_ACCOUNT_ORDER_LIST' | 'MY_ACCOUNT_RETURNS_LIST' | 'MY_ACCOUNT_WALLET' | 
    'MULTI_WISHLIST_NEW_LIST' | 'ORDER_REFUND_CONFIRMATION' | 'PASSWORD_RECOVERY' | 'PASSWORD_RECOVERY_RESET' | 
    'POLICIES_PRIVACY' | 'POLICIES_PURCHASE_CONDITIONS' | 'PRODUCT_BUNDLE_DETAILS' | 'PRODUCT_DETAILS' | 
    'PRODUCT_LIST' | 'PRODUCT_SEARCH_RESULTS' | 'PRODUCT_SEARCH_START' | 'PURCHASE_ORDER_END' | 
    'RETURNABLE_PRODUCTS_SELECTOR' | 'CHECKOUT_PAYMENT_METHOD_SAVED' | 'SAVE_FOR_LATER' | 'SCAN_AND_ADD_CODE' | 
    'SEARCH_REQUEST' | 'SHOPPING_CART' | 'SIRI_SHORTCUT_CONFIRMATION' | 'SMART_WAITING_ROOM' | 'SPLASH' | 
    'STORE_AVAILABILITY' | 'STORE_MODE_STORE_DETAIL' | 'STORE_COLLECTION_POINT_MAP' | 'STORE_OPENING_TIMES' | 
    'STORE_MODE_IN_STORE_LOCATION_SELECTION' | 'STORE_MODE_IN_STORE_LOCATION_SELECTION_ALL' | 
    'STORE_MODE_IN_STORE_LOCATION_MAP' | 'STORE_MODE_IN_STORE_LOCATION_STOCKROOM' | 
    'STORE_MODE_IN_STORE_LOCATION_PROMO' | 'STORE_MODE_IN_STORE_LOCATOR_QR' | 'STORE_MODE_PRODUCT_DETAILS_LITE' | 
    'TAB_BAR' | 'USER_ACCOUNT_DELETION' | 'USER_ACCOUNT_DELETION_CONFIRMATION' | 'USER_LOGON' | 
    'USER_REGISTRATION'

export function pushToDataLayer(data: ViewDataLayerObject | InteractionDataLayerObject): void {
    dataLayer.push(data);
}

export function pushToApps(event) {
    const customWindow: Window = window;

    const adjustedEvent = {
        ...event,
        eventData: {
            ...event.eventData,
            content_group: "zara_resell",
        }
    };

    const analyticsEventFormat = {
        name: "sendAnalyticsEvent",
        payload: adjustedEvent,
    };

    if (isAndroid()) {
        customWindow?.Android?.handler(JSON.stringify(analyticsEventFormat));
    } else if (isIOS()) {
        customWindow?.webkit?.messageHandlers?.handler?.postMessage(JSON.stringify(analyticsEventFormat));
    }
}


export function normalizeString(inputStr: string | null | undefined): string {
    if (inputStr === null || inputStr === undefined) {
        return '';
    }
    return inputStr.trim().toLowerCase();
}


export const formatDecimalPrice = (priceDto: ProductPriceDto): string => {
    if (priceDto?.value !== undefined && priceDto?.exponent !== undefined) {
        const decimalPrice = priceDto.value / Math.pow(10, priceDto.exponent);
        return decimalPrice.toFixed(2).replace('.', ',');
    }
    return "0,00";
};

export const useCachedUniverse = () :UseQueryResult<AxiosResponse<PageUniverseDto, any>, unknown>=>{
    const queryClient = useQueryClient();
  
    const cachedUniverse = queryClient.getQueryData<UseQueryResult<AxiosResponse<PageUniverseDto, any>, unknown>>(["getUniverse"]);
  
    return cachedUniverse;
  }

/**
 * Find universe by universeId from cache
 */
export function findUniverseByIdFromCache(
    cachedUniverse: PageUniverseDto | undefined, 
    universeId: number
  ) {
    if (!cachedUniverse?.content) return undefined;
    return cachedUniverse.content.find((universe) => universe.id === universeId);
  }
  
  /**
   * Find grid by gridId from cache within a universe
   */
  export function findGridByIdFromCache(
    universe: PageUniverseDto['content'][number], 
    gridId: number
  ) {
    return universe?.grids?.find((grid) => grid.id === gridId);
  }

